import { render, staticRenderFns } from "./organizationTree.vue?vue&type=template&id=912e7c8a&"
import script from "./organizationTree.vue?vue&type=script&lang=js&"
export * from "./organizationTree.vue?vue&type=script&lang=js&"
import style0 from "./organizationTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports